import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { Auth } from 'src/app/core/common/auth';
import { NavigationComponent } from 'src/app/navigation/navigation.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [AsyncPipe, NavigationComponent, LoadingComponent, DialogsModule],
})
export class AppComponent {
  constructor(protected auth: Auth) {}
}
